import { render, staticRenderFns } from "./JsonStructureField.vue?vue&type=template&id=5d6613a0&scoped=true"
import script from "./JsonStructureField.vue?vue&type=script&lang=js"
export * from "./JsonStructureField.vue?vue&type=script&lang=js"
import style0 from "./JsonStructureField.vue?vue&type=style&index=0&id=5d6613a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6613a0",
  null
  
)

export default component.exports